import api from '../services/api';

/**
 * Fetches a node's binary stream with auth headers and returns a blob URL.
 * Replaces the 4 identical fetch-blob patterns in NodeDetailPanel.
 */
export default async function streamBlob(nodeId) {
  const res = await fetch(`${api.getBaseUrl()}/nodes/${nodeId}/stream`, {
    headers: api.getAuthHeaders(),
  });
  if (!res.ok) throw new Error(`Stream failed: ${res.status}`);
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
